<template>
  <ag-card-container
    :search.sync="search"
    :title="$t('user.title.userList')"
    fluid
  >
    <user-list
      :value="userList"
      :selected.sync="selectedUserList"
      :loading="loadingData"
      :search="search"
    >
      <template #footer>
        <v-btn
          color="accent"
          small
          append
          to="restore"
          v-text="$t('user.title.restoreUser')"
        />
      </template>
    </user-list>

    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedUserList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedUserList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="create"
        append
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import _map from 'lodash/map'
import { mapActions, mapGetters } from 'vuex'
import Repositories from 'src/repositories'
import UserList from '../components/UserList'

export default {
  name: 'UserListContainer',
  components: {
    AgCardContainer,
    AgFloatButtonContainer,
    AgConfirmDialog,
    UserList,
  },
  data: () => ({
    userList: [],
    selectedUserList: [],
    search: '',
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    ...mapGetters('me', {
      userId: 'userId',
    }),
    removeMessage () {
      const count = this.selectedUserList.length
      return this.$tc('user.remove.message', count, { count })
    },
    hasCurrentUserInSelected () {
      return this.selectedUserList
        .some(user => user.userId === this.userId)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'UserList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.userList = await Repositories.user.getList()
      this.loadingData = false
    },
    async removeSelected () {
      if (this.hasCurrentUserInSelected) {
        const notification = this.$t('user.remove.cantRemoveCurrentUser')
        this.showErrorNotification(notification)
      }
      else {
        try {
          this.loadingRemove = true
          const count = this.selectedUserList.length
          await Repositories.user.delete(_map(this.selectedUserList, 'userId'))
          const notification = this.$tc('user.remove.success', count, { count })
          this.showSuccessNotification(notification)
        }
        catch (error) {
          const notification = Repositories.parseErrorMessage(error)
          this.showErrorNotification(notification)
        }
        finally {
          this.loadingRemove = false
          this.selectedUserList = []
          this.fetchData()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
